"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ComponentWithPartials = _interopRequireDefault(require("../mixins/ComponentWithPartials"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _OptionTypes = require("../types/OptionTypes");

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _UITypeaheadUtils = require("./UITypeaheadUtils");

var _UITypeaheadResults = _interopRequireDefault(require("./results/UITypeaheadResults"));

var _UITypeaheadResultsGroup = _interopRequireDefault(require("./results/UITypeaheadResultsGroup"));

var _UITypeaheadResultsItem = _interopRequireDefault(require("./results/UITypeaheadResultsItem"));

var _UITypeaheadSearch = _interopRequireDefault(require("./search/UITypeaheadSearch"));

var _underscore = require("../utils/underscore");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

function getFlattenedOptions(groupedOptions) {
  var groups = [];
  var options = [];
  groupedOptions.forEach(function (option) {
    if (option.hasOwnProperty('options')) {
      var groupIdx = groups.push(option) - 1;
      option.options.forEach(function (groupOption) {
        options.push((0, _extends2.default)({}, groupOption, {
          groupIdx: groupIdx
        }));
      });
    } else {
      options.push((0, _extends2.default)({}, option, {
        groupIdx: -1
      }));
    }
  });
  return {
    options: options,
    groups: groups
  };
}

function getHighlightedIndex(component, filtered) {
  return filtered.options.indexOf(component.getHighlighted(filtered));
}

var KeyHandlers = {
  ArrowDown: function ArrowDown(component) {
    var filtered = component.getFilteredOptions();
    var options = filtered.options;
    var nextIndex = (getHighlightedIndex(component, filtered) + 1) % options.length;
    component.setState({
      highlighted: options[nextIndex],
      highlightedId: component.getResultItemId(options[nextIndex])
    });
  },
  Enter: function Enter(component, evt) {
    component.handleChange(component.getHighlighted(component.getFilteredOptions()), evt);
  },
  ArrowUp: function ArrowUp(component) {
    var filtered = component.getFilteredOptions();
    var options = filtered.options;
    var index = getHighlightedIndex(component, filtered);
    var nextIndex = index === 0 ? options.length - 1 : index - 1;
    component.setState({
      highlighted: options[nextIndex],
      highlightedId: component.getResultItemId(options[nextIndex])
    });
  }
};

var UITypeaheadCore = _react.default.createClass({
  displayName: "UITypeaheadCore",
  mixins: [_reactAddonsPureRenderMixin.default, _ComponentWithPartials.default],
  propTypes: {
    autoFilter: _react.PropTypes.bool,
    hideResults: _react.PropTypes.bool,
    itemComponent: _component.default,
    minimumSearchCount: _react.PropTypes.number,
    onChange: _react.PropTypes.func,
    onSearchChange: _react.PropTypes.func,
    options: _react.PropTypes.arrayOf(_OptionTypes.OptionOrGroupType.isRequired).isRequired,
    placeholder: _react.PropTypes.string,
    resultsClassName: _react.PropTypes.string,
    search: _react.PropTypes.string,
    searchClassName: _react.PropTypes.string,
    value: _OptionTypes.SingleValueType
  },
  getDefaultProps: function getDefaultProps() {
    return {
      autoFilter: true,
      hideResults: false,
      itemComponent: 'li',
      minimumSearchCount: 0,
      search: ''
    };
  },
  getInitialState: function getInitialState() {
    var _this$props = this.props,
        autoFilter = _this$props.autoFilter,
        options = _this$props.options,
        search = _this$props.search;
    return {
      flattened: getFlattenedOptions(options),
      highlighted: null,
      highlightedId: null,
      searchRegex: autoFilter ? (0, _UITypeaheadUtils.getSearchRegExp)(search) : undefined
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var options = _ref.options,
        search = _ref.search;

    if (options !== this.props.options) {
      this.setState({
        flattened: getFlattenedOptions(options)
      });
    }

    if (this.props.autoFilter && search !== this.props.search) {
      this.setState({
        searchRegex: (0, _UITypeaheadUtils.getSearchRegExp)(search)
      });
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    var highlightedNode = (0, _reactDom.findDOMNode)(this._highlightedRef);

    if (!highlightedNode) {
      return;
    }

    var offsetHeight = highlightedNode.offsetHeight,
        offsetParent = highlightedNode.offsetParent,
        offsetTop = highlightedNode.offsetTop;
    var scrollTop = offsetParent.scrollTop;

    if (scrollTop > offsetTop) {
      offsetParent.scrollTop = offsetTop;
    }

    var nodeBottom = offsetHeight + offsetTop;
    var parentBottom = scrollTop + offsetParent.offsetHeight;

    if (parentBottom >= nodeBottom) {
      return;
    }

    offsetParent.scrollTop = scrollTop + nodeBottom - parentBottom;
  },
  focus: function focus() {
    if (this._searchRef) {
      this._searchRef.focus();
    }
  },
  getClassName: function getClassName() {
    return (0, _classNames.default)('private-dropdown', 'private-typeahead', {
      'hide-search': this.getSearchCount() < this.props.minimumSearchCount
    }, this.props.className);
  },
  getFilteredOptions: function getFilteredOptions() {
    var _this$state = this.state,
        searchRegex = _this$state.searchRegex,
        flattened = _this$state.flattened;
    var results = searchRegex ? flattened.options.filter(function (_ref2) {
      var dropdownText = _ref2.dropdownText,
          text = _ref2.text,
          value = _ref2.value;
      return searchRegex.test(text) || searchRegex.test("" + value) || typeof dropdownText === 'string' && searchRegex.test(dropdownText);
    }) : flattened.options;
    return {
      groups: flattened.groups,
      options: results.length ? results : [(0, _UITypeaheadUtils.getNoMatchesOption)()]
    };
  },
  getHighlighted: function getHighlighted(filtered) {
    var value = this.props.value;
    var highlighted = this.state.highlighted;

    if (highlighted && filtered.options.indexOf(highlighted) > -1) {
      return highlighted;
    }

    return filtered.options.find(function (option) {
      return option.value === value;
    }) || filtered.options[0] || null;
  },
  getResultItemId: function getResultItemId(option) {
    return this._id + "_" + this.state.flattened.options.indexOf(option);
  },
  getSearchCount: function getSearchCount() {
    var flattened = this.state.flattened;

    if (!flattened || !flattened.options) {
      return -1;
    }

    return flattened.options.length + flattened.groups.length;
  },
  handleChange: function handleChange(option, evt) {
    if (option.disabled) {
      return;
    }

    this.handleHighlight(option, evt);
    var onChange = this.props.onChange;
    onChange((0, _SyntheticEvent.default)(option.value, evt));
  },
  handleHighlight: function handleHighlight(option, evt) {
    var highlighted = this.state.highlighted;

    if (highlighted === option) {
      return;
    }

    this.setState({
      highlighted: option,
      highlightedId: evt.currentTarget.id
    });
  },
  handleKeyDown: function handleKeyDown(evt) {
    if (KeyHandlers.hasOwnProperty(evt.key)) {
      evt.preventDefault();
      KeyHandlers[evt.key](this, evt);
    }
  },
  searchRefCallback: function searchRefCallback(ref) {
    this._searchRef = ref;
  },
  renderFilteredOptions: function renderFilteredOptions() {
    var _this = this;

    var filtered = this.getFilteredOptions();
    var groups = filtered.groups;
    var highlighted = this.getHighlighted(filtered);
    var groupIdx = -1;
    var groupedOptions = [];
    var options = [];
    filtered.options.forEach(function (option) {
      if (option.groupIdx !== groupIdx) {
        if (groupedOptions.length) {
          options.push(_this.renderResultsGroup(groups[groupIdx], groupedOptions, highlighted));
        }

        groupIdx = option.groupIdx;
        groupedOptions = [];
      }

      if (option.groupIdx === -1) {
        options.push(_this.renderResultsItem(option, highlighted));
      } else {
        groupedOptions.push(option);
      }
    });

    if (groupedOptions.length) {
      options.push(this.renderResultsGroup(groups[groupIdx], groupedOptions, highlighted));
    }

    return options;
  },
  renderResults: function renderResults(_ref3) {
    var id = _ref3.id,
        hideResults = _ref3.hideResults,
        resultsClassName = _ref3.resultsClassName;

    if (hideResults) {
      return null;
    }

    return _react.default.createElement(_UITypeaheadResults.default, {
      id: id,
      className: resultsClassName
    }, this.renderFilteredOptions());
  },
  renderResultsGroup: function renderResultsGroup(group, options, highlighted) {
    var _this2 = this;

    return _react.default.createElement(_UITypeaheadResultsGroup.default, {
      group: group,
      key: group.value || group.options[0].value
    }, options.map(function (option) {
      return _this2.renderResultsItem(option, highlighted);
    }));
  },
  renderResultsItem: function renderResultsItem(option, highlighted) {
    var _this3 = this;

    if (option === (0, _UITypeaheadUtils.getNoMatchesOption)()) {
      return this.renderResultsEmpty();
    }

    var isHighlighted = highlighted === option;
    return _react.default.createElement(_UITypeaheadResultsItem.default, {
      highlighted: isHighlighted,
      itemComponent: this.props.itemComponent,
      key: option.value,
      onClick: this.partial(this.handleChange, option),
      onMouseEnter: this.partial(this.handleHighlight, option),
      option: option,
      ref: isHighlighted ? function (ref) {
        _this3._highlightedRef = ref;
      } : undefined,
      search: this.state.searchRegex,
      id: this.getResultItemId(option)
    });
  },
  renderResultsEmpty: function renderResultsEmpty() {
    return _react.default.createElement(_UITypeaheadResultsItem.default, {
      disabled: true,
      itemComponent: this.props.itemComponent,
      key: (0, _UITypeaheadUtils.getNoMatchesOption)().value,
      option: (0, _UITypeaheadUtils.getNoMatchesOption)()
    });
  },
  renderSearch: function renderSearch(_ref4) {
    var ariaControls = _ref4.ariaControls,
        current = _ref4.current,
        onSearchChange = _ref4.onSearchChange,
        search = _ref4.search,
        searchClassName = _ref4.searchClassName,
        rest = (0, _objectWithoutProperties2.default)(_ref4, ["ariaControls", "current", "onSearchChange", "search", "searchClassName"]);
    return _react.default.createElement(_UITypeaheadSearch.default, (0, _extends2.default)({}, rest, {
      "aria-activedescendant": current,
      "aria-controls": ariaControls,
      className: searchClassName,
      onChange: onSearchChange,
      onKeyDown: this.handleKeyDown,
      value: search,
      ref: this.searchRefCallback
    }));
  },
  render: function render() {
    var _this$props2 = this.props,
        __autoFilter = _this$props2.autoFilter,
        hideResults = _this$props2.hideResults,
        __itemComponent = _this$props2.itemComponent,
        __minimumSearchCount = _this$props2.minimumSearchCount,
        onSearchChange = _this$props2.onSearchChange,
        __options = _this$props2.options,
        resultsClassName = _this$props2.resultsClassName,
        search = _this$props2.search,
        searchClassName = _this$props2.searchClassName,
        style = _this$props2.style,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["autoFilter", "hideResults", "itemComponent", "minimumSearchCount", "onSearchChange", "options", "resultsClassName", "search", "searchClassName", "style"]);
    var highlightedId = this.state.highlightedId;
    this._id = this._id || (0, _underscore.uniqueId)('typeahead-');
    var renderedSearch = this.renderSearch((0, _extends2.default)({
      ariaControls: this._id,
      current: highlightedId,
      onSearchChange: onSearchChange,
      search: search,
      searchClassName: searchClassName
    }, rest));
    var renderedResults = this.renderResults({
      id: this._id,
      hideResults: hideResults,
      resultsClassName: resultsClassName
    });
    return _react.default.createElement("div", {
      "aria-expanded": true,
      "aria-haspopup": "listbox",
      "aria-controls": this._id,
      className: this.getClassName(),
      role: "combobox",
      style: style
    }, renderedSearch, renderedResults);
  }
});

UITypeaheadCore.displayName = 'UITypeahead';
var UITypeahead = (0, _Controllable.default)(UITypeaheadCore, ['search', 'value']);
UITypeahead.noMatchesI18nKey = 'salesUI.UITypeahead.noMatchesFound';
UITypeahead.noOptionsI18nKey = 'salesUI.UITypeahead.noOptions';
var _default = UITypeahead;
exports.default = _default;
module.exports = exports.default;